import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon, PackageIcon, UsersIcon, UserXIcon, GiftIcon } from 'lucide-react';
export function OfferDetails() {
  const deliverables = ['El Manual Maestro "Emprende con Repostería Casera" (PDF de alta densidad).', 'Las 5 Recetas "Imán de Ventas" optimizadas para bajo costo y alta rotación.', 'La Hoja de Costo Real (HCR): El sistema para calcular el precio exacto por gramo.', 'Guía de Sustitución Técnica: Qué hacer cuando un ingrediente desaparece o sube de precio.', 'Protocolo de Ventas por WhatsApp: Cómo cerrar pedidos sin perseguir a nadie.'];
  const whoIsFor = ['Personas que necesitan generar ingresos extra desde su casa inmediatamente.', 'Reposteros entusiastas que no logran ver ganancias reales a final de mes.', 'Madres y padres de familia que tienen un horno básico y quieren ponerlo a producir.', 'Emprendedores que buscan un negocio de baja inversión y alta rotación diaria.'];
  const whoIsNotFor = ['Personas que buscan recetas de alta pastelería con ingredientes importados.', 'Quienes no estén dispuestos a pesar sus ingredientes y llevar un control de costos estricto.', 'Gente que busca "dinero mágico" sin encender el horno.'];
  return <section className="py-16 px-6 bg-cream-dark" data-id="element-58">
      <div className="max-w-4xl mx-auto space-y-12" data-id="element-59">
        {/* What You Get */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-10 rounded-3xl shadow-warm" data-id="element-60">
          <div className="flex items-center gap-4 mb-8" data-id="element-61">
            <PackageIcon className="w-8 h-8 text-amber" data-id="element-62" />
            <h2 className="text-3xl font-bold" data-id="element-63">Lo que te llevas hoy:</h2>
          </div>

          <ul className="space-y-4 mb-8" data-id="element-64">
            {deliverables.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-cream p-4 rounded-xl" data-id="element-65">
                <div className="mt-1 bg-success/20 p-1 rounded-full shrink-0" data-id="element-66">
                  <CheckIcon className="w-5 h-5 text-success" data-id="element-67" />
                </div>
                <span className="text-lg text-chocolate font-medium" data-id="element-68">
                  {item}
                </span>
              </motion.li>)}
          </ul>

          {/* Bonus Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="border-t-2 border-amber/20 pt-8" data-id="element-69">
            <div className="flex items-center gap-3 mb-6" data-id="element-70">
              <div className="bg-amber/20 p-2 rounded-full" data-id="element-71">
                <GiftIcon className="w-6 h-6 text-amber" data-id="element-72" />
              </div>
              <h3 className="text-2xl font-bold text-amber-dark" data-id="element-73">
                + BONOS EXCLUSIVOS DE ACCESO INSTANTÁNEO
              </h3>
            </div>

            <div className="bg-gradient-to-br from-amber/5 to-terracotta/5 p-6 rounded-2xl border-2 border-amber/30" data-id="element-74">
              <img src="https://cdn.magicpatterns.com/uploads/8ZmnzPHRYn1nioCwAYqyTv/bono_1.jpg" alt="Bonos exclusivos - Manual de Repostería Casera con acceso instantáneo" className="w-full rounded-xl shadow-warm-lg mb-4" data-id="element-75" />
              <div className="flex items-center justify-center gap-2 bg-amber text-white px-4 py-2 rounded-full font-bold text-sm uppercase tracking-wider" data-id="element-76">
                <GiftIcon className="w-4 h-4" data-id="element-77" />
                <span data-id="element-78">Acceso Inmediato al Completar tu Compra</span>
              </div>
            </div>
          </motion.div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-79">
          {/* Who this is for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 rounded-3xl shadow-warm border-t-4 border-success" data-id="element-80">
            <div className="flex items-center gap-3 mb-6" data-id="element-81">
              <UsersIcon className="w-6 h-6 text-success" data-id="element-82" />
              <h3 className="text-2xl font-bold" data-id="element-83">Para quién es esto:</h3>
            </div>
            <ul className="space-y-4" data-id="element-84">
              {whoIsFor.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-85">
                  <CheckIcon className="w-5 h-5 text-success shrink-0 mt-1" data-id="element-86" />
                  <span className="text-chocolate/80" data-id="element-87">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who this is not for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-white p-8 rounded-3xl shadow-warm border-t-4 border-danger" data-id="element-88">
            <div className="flex items-center gap-3 mb-6" data-id="element-89">
              <UserXIcon className="w-6 h-6 text-danger" data-id="element-90" />
              <h3 className="text-2xl font-bold" data-id="element-91">Para quién NO es:</h3>
            </div>
            <ul className="space-y-4" data-id="element-92">
              {whoIsNotFor.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-93">
                  <XIcon className="w-5 h-5 text-danger shrink-0 mt-1" data-id="element-94" />
                  <span className="text-chocolate/80" data-id="element-95">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}